import PercentSplit from "./percentSplitGraph"
export default PercentSplit